var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2"},[_c('a',{staticClass:"class",attrs:{"href":_vm.helpLink,"target":"blank","rel":"noopener noreferrer"}},[_vm._v("\n        "+_vm._s(_vm.helpLinkText)+"    \n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8342960","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/framework/primitives/AmfHelpLink.vue
// module id = null
// module chunks = 